import React from "react";
import Subscriber from "../../subscriber.class";
// import Spinner from "../../components/Spinners/Spinner";
import Storage from "../../services/storage.service";
// import Globals from "./../../services/globals";
// import User from "../../services/user";
// import Settings from "../../services/settings";

import ClosureInquiry from "./closure_inquiry";
import Chats from "../../services/chat.service";

export default class SingleChat extends Subscriber {
  state = {
    messages: [],
    waiting: false,
    confirmed: false,
    declined: false,
    ticket: null
  };

  scroller = null;

  componentDidMount() {
    this.scroller = document.getElementById("messages");
    this.scroller.scrollTop = this.scroller.scrollHeight;

    this.subscriptions.push(
      Storage.get_obsrv("ticket_inquiry_count").subscribe(messages => {
         let ticket = Storage.get("active_ticket")
         if(ticket){
           Chats.loadMessages(ticket.channel);
         }
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("ticket_messages").subscribe(messages => {
        this.setState({
          messages: messages
        });

        setTimeout(() => {
          this.scroller = document.getElementById("messages");
          if (this.scroller) {
            this.scroller.scrollTop = this.scroller.scrollHeight;
          }
        }, 2);
      })
    );
    this.subscriptions.push(
      Storage.get_obsrv("active_ticket").subscribe(ticket => {
        this.setState({
          ticket: ticket
        });
        if (ticket) {
          Chats.loadMessages(ticket.channel);
        }
      })
    );
  }

  render() {
    // let content = "";
    
    let messages = [];
    let open_ticket = "";

    if (this.state.messages) {
      for (let message of this.state.messages) {
        let sender = "Agent";
        let sender_name = "Desk";

        if (message._sender && message._sender.nickname) {
          sender_name = message._sender.nickname;
        }

        if (message.customType === "UserMessage") {
          sender = "User";
          sender_name = "User";
        }

        let inquiry = Chats.checkForResolveInquiry(message);

        let admin = message.messageType === "admin" ? "Admin" : "";

        let action = "";

        let classes =
          "ticket_message " + sender + "_message " + admin + " " + inquiry;

        if (
          inquiry === "WAITING" ||
          inquiry === "CONFIRMED" ||
          inquiry === "CLOSED" ||
          inquiry === "DECLINED"
        ) {
          messages.push(
            <div key={message.messageId} className={classes}>
              <ClosureInquiry message={message} inquiry={inquiry} />
            </div>
          );
        } else {
          messages.push(
            <div key={message.messageId} className={classes}>
              {action}
              <div className="ticket_message_inner">
                <span className="msg">
                  {sender !== "User" ? (
                    <span className="sender">{sender_name}</span>
                  ) : (
                    ""
                  )}
                  <span className="msg-inner">{message.message}</span>
                </span>
              </div>
            </div>
          );
        }
      }
      open_ticket = (
        <div className="open_ticket">
          <div className="messages_wrapper">
            <div className="messages" id="messages">
              {messages}
            </div>
          </div>
        </div>
      );
    }

    return open_ticket;
  }
}
